// Type definition for filter elements
type FilterElement = {
	slug: string;
	title: string;
};

const filterForm = document.querySelector('#filter-form') as HTMLFormElement;
const locationFilter = document.querySelector('#location-filter') as HTMLSelectElement;
const categoryFilter = document.querySelector('#category-filter') as HTMLSelectElement;
const searchInput = document.querySelector('#search-jobs') as HTMLInputElement;
const noResults = document.querySelector('#no-job-results') as HTMLElement;
const searchFilterDrawer = document.querySelector('#search-filter-drawer') as HTMLElement;
const searchFilterDrawerCount = document.querySelector('#results-count') as HTMLElement;
const jobListWrapper = document.querySelector('.job-list-wrapper') as HTMLElement;
const jobsLoadButton = document.querySelector('#jobs-load-more') as HTMLButtonElement;
const jobs = document.querySelectorAll('.job') as NodeListOf<HTMLElement>;
const loadMoreCount = 10;

if (locationFilter) {
	const url = new URL(window.location.href);

	const filters = {
		location: {
			selected: url.searchParams.get('location'),
			ui: locationFilter as HTMLSelectElement,
			elems: [] as Array<FilterElement>,
		},
		category: {
			selected: url.searchParams.get('category'),
			ui: categoryFilter as HTMLSelectElement,
			elems: [] as Array<FilterElement>,
		},
	};

	// Get deduped filters from jobs
	jobs.forEach((job: HTMLElement) => {
		Object.keys(filters).forEach((filterKey) => {
			const key = filterKey as keyof typeof filters;
			const jobMeta: FilterElement = {
				slug: job.dataset[key] || '',
				title: job.dataset[key + 'Title'] || '',
			};
			if (
				filters[key].elems.filter((c) => c.slug === jobMeta.slug).length === 0 &&
				jobMeta.slug !== ''
			) {
				filters[key].elems.push(jobMeta);
			}
		});
	});

	// Sort filters, add to select ui, set filter from url
	Object.keys(filters).forEach((filterKey) => {
		const key = filterKey as keyof typeof filters;
		filters[key].elems = filters[key].elems.sort((a, b) => a.slug.localeCompare(b.slug));
		filters[key].elems.forEach((elem) => {
			const option = document.createElement('option');
			option.value = elem.slug;
			option.text = elem.title;
			filters[key].ui?.add(option);
			if (filters[key].selected === elem.slug) {
				filters[key].ui.value = elem.slug;
			}
		});
	});

	// Submit filter form listener.
	filterForm.addEventListener('submit', function (e) {
		e.preventDefault();
		displayJobs(categoryFilter.value, locationFilter.value, searchInput.value);
		setLoadMore();
	});

	// Clear filters listener.
	document.querySelectorAll('[data-clear-results]').forEach((elem) => {
		elem.addEventListener('click', function (e) {
			e.preventDefault();
			categoryFilter.value = 'all';
			locationFilter.value = 'all';
			searchInput.value = '';
			displayJobs(categoryFilter.value, locationFilter.value, searchInput.value);
			setLoadMore();
		});
	});

	// Load more listener.
	if (jobsLoadButton) {
		jobsLoadButton.addEventListener('click', function () {
			const filteredJobs = document.querySelectorAll('.job.d-none:not(.disabled)');
			filteredJobs.forEach((job, index) => {
				if (index < loadMoreCount) {
					job.classList.remove('d-none');
				}
			});

			if (document.querySelectorAll('.job.d-none:not(.disabled)').length === 0) {
				jobsLoadButton.classList.add('d-none');
			}
		});
	}

	// Init.
	displayJobs(categoryFilter.value, locationFilter.value, searchInput.value);
	setLoadMore();
}

function setLoadMore() {
	if (document.querySelectorAll('.job.d-none:not(.disabled)').length === 0) {
		jobsLoadButton?.classList.add('d-none');
	}

	let visibleJobs = 0;
	jobs.forEach((job) => {
		if (!job.classList.contains('disabled') || !job.classList.contains('d-none')) {
			visibleJobs++;
		}
		if (visibleJobs > loadMoreCount) {
			job.classList.add('d-none');
		}
	});
	if (visibleJobs > loadMoreCount) {
		jobsLoadButton.classList.remove('d-none');
	} else {
		jobsLoadButton.classList.add('d-none');
	}
}

function orderInitial(a: HTMLElement, b: HTMLElement) {
	const aValue = parseInt(a.dataset.orderInitial || '0');
	const bValue = parseInt(b.dataset.orderInitial || '0');

	if (aValue < bValue) return -1;
	if (aValue > bValue) return 1;
	return 0;
}
function orderSearchPriority(a: HTMLElement, b: HTMLElement) {
	const aValue = parseInt(a.dataset.searchpriority || '0');
	const bValue = parseInt(b.dataset.searchpriority || '0');

	if (aValue > bValue) return -1;
	if (aValue < bValue) return 1;
	return 0;
}

function displayJobs(category: string, location: string, searchTerm: string) {
	const url = new URL(window.location.href);
	if (category && category !== 'all') {
		url.searchParams.set('category', category);
	} else {
		url.searchParams.delete('category');
	}

	if (location && location !== 'all') {
		url.searchParams.set('location', location);
	} else {
		url.searchParams.delete('location');
	}

	if (searchTerm) {
		url.searchParams.set('search', searchTerm);
	} else {
		url.searchParams.delete('search');
	}

	window.history.pushState({}, '', url);
	let isSearching = false;

	Array.from(jobs).forEach((job) => job.classList.remove('d-none', 'disabled'));

	if (category && category !== 'all') {
		isSearching = true;
		Array.from(jobs)
			.filter((job) => job.dataset.category !== category)
			.forEach((job) => job.classList.add('d-none', 'disabled'));
	}

	if (location && location !== 'all') {
		isSearching = true;
		Array.from(jobs)
			.filter((job) => job.dataset.location !== location)
			.forEach((job) => job.classList.add('d-none', 'disabled'));
	}

	if (searchTerm) {
		isSearching = true;
		const searchTerms = searchTerm.toLowerCase().split(' ');
		Array.from(jobs)
			.filter((job) => {
				let hasTerm = false;
				let searchPriority = 0;
				searchTerms.forEach((term) => {
					if (job.dataset.searchprimary?.includes(term)) {
						hasTerm = true;
						searchPriority += 10;
					}
					if (job.dataset.search?.includes(term)) {
						hasTerm = true;
						searchPriority += 1;
					}
				});
				job.dataset.searchpriority = searchPriority.toString();
				return !hasTerm;
			})
			.forEach((job) => {
				job.classList.add('d-none', 'disabled');
			});
	}

	// Set no results
	const activeJobs = Array.prototype.filter.call(jobs, function (job) {
		return !job.matches('.disabled');
	});
	if (0 === activeJobs.length) {
		noResults.classList.remove('d-none');
	} else {
		noResults.classList.add('d-none');
	}

	if (isSearching && 0 !== activeJobs.length) {
		searchFilterDrawerCount.innerHTML =
			'Showing ' + activeJobs.length + ' result' + (activeJobs.length !== 1 ? 's' : '');
		searchFilterDrawer.classList.remove('d-none');

		Array.from(jobs)
			.sort(orderSearchPriority)
			.forEach((e) => jobListWrapper.appendChild(e));
	} else {
		searchFilterDrawer.classList.add('d-none');

		Array.from(jobs)
			.sort(orderInitial)
			.forEach((e) => jobListWrapper.appendChild(e));
	}

	// Reset screen size
	window.dispatchEvent(new Event('resize'));
}
